<template>
    <div>
      <div v-if="!isObject">
        <multiselect
            :model-value="selected"
            :options="options"
            :label="field"
            mode="tags"
            :track-by="field"
            :value-prop='track'
            @search-change="(query) => handleSearch(query)"
            @update:modelValue="selected = $event"
            :loading="isLoading"
            :limit="limit"
            :max="max"
            :placeholder="placeholder"
            :max-height="300"
            :tag-position="'bottom'"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            :searchable="true"
            :disabled="disabled"
            @open="handleOpen"
            ref="multicomplete"

        >
          <template #noresults>
            <span>No items found.</span>
          </template>
          <template v-slot:option="{ option }">
            {{ option.full_name || option[fieldName] }}
          </template>
        </multiselect>
      </div>
      <div v-else>
        <multiselect
            :model-value="selected"
            :options="options"
            :label="field"
            :can-deselect="true"
            mode="tags"
            :object="true"
            :track-by="field"
            :multiple="true"
            :value-prop='track'
            :infinite="true"
            @search-change="handleSearch"
            @update:modelValue="selected = $event"
            @open="handleOpen"
            :loading="isLoading"
            :limit="limit"
            :max="max"
            :placeholder="placeholder"
            :max-height="300"
            :tag-position="'bottom'"
            :searchable="true"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            :disabled="disabled"
            ref="multicomplete"
        >
          <template #noresults>
            <span>No items found.</span>
          </template>
        </multiselect>
      </div>

        <form-error :error="error" />

        <select v-if="selectForClassicFormName" multiple :name="selectForClassicFormName" style="display: none;">
            <option v-for="s in selected" :value="s.id" :key="s.id" selected>{{ s.id }} </option>
        </select>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Multiselect from '@vueform/multiselect'

    const getAsyncItems = (field, data) => payload => new Promise((resolve, reject) => {
            let items = payload[field] ?
                _.filter(data, item => item[field].toLowerCase().includes(payload[field].toLowerCase())) :
                data
            resolve({
                data: {data: items}
            })
    })

    export default {
        props: {
            disabled: {type: Boolean},
            type: {type: String},
            values: {type: Array, default: () => []},
            value: {type: Object, default: () => {}},
            placeholder: {type: String},
            fieldName: {type: String},
            optionsProp: {type: Array, default: () => []},
            optionsProp2: {type: Number},
            error: {type: String},
            limit: {type: Number, default: 5},
            max: {type: Number, default: 99},
            // used to download the transmittal pdf (project/contacts actions)
            selectForClassicFormName: {type: String, default: ''},
            track: {
              type: String,
              default: 'id'
            },
          isObject:{
            type: Boolean,
            default: false
          }
        },

        components: {
            Multiselect
        },

        data() {
            return {
                isLoading: false,
                options: [],
                timer: null
            }
        },

      mounted() {
            if (['custom'].includes(this.type)) {
                this.options = this.optionsProp
            }
        setTimeout(() => {
          if (['company_contacts', 'contacts'].includes(this.type) && this.value) {
            this.$refs.multicomplete.iv = []
              this.$refs.multicomplete.iv = this.$refs.multicomplete.$parent.value
          }

          if (['custom'].includes(this.type) && this.value) {
            this.$refs.multicomplete.iv = []
              this.$refs.multicomplete.iv = this.$refs.multicomplete.$parent.value
          }
        }, 2000)

            // this.fetchContacts()
        },

        computed: {
            ...mapGetters(['users', 'services', 'contacts', 'contactById']),

            computedOptions() {
                return [ 'custom'].includes(this.type) ? this.optionsProp : this.options
            },

            field() {
                switch(this.type) {
                    case 'company_contacts':
                    case 'project':
                        return 'full_name'
                    case 'user':
                        return 'full_name'
                    case 'task':
                        return 'title'
                    case 'contact':
                        return 'full_name'
                    case 'service':
                        return 'title'
                    case 'custom': 
                        return this.fieldName || 'label'
                    default:
                        return 'label'
                }
            },

           selected: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('update:modelValue', value)
                }
            },
        },

        watch:{
          'options'(value){
            this.$emit('click', this.options)
          },
          'value'(value){
          }
        },


        methods: {
            ...mapActions(['fetchProjects', 'fetchTasks', 'fetchContacts', 'fetchUsers',]),

            fetchItems() {
                switch(this.type) {
                    case 'project':
                        return this.fetchProjects
                    case 'project':
                        return this.fetchTasks
                    case 'user':
                        return payload => {
                          return new Promise((resolve, reject) => {
                            let items = payload.full_name ?
                                _.filter(this.users, item => {
                                  return item.full_name.toLowerCase().includes(payload.full_name.toLowerCase())
                                }) :
                                this.users

                            resolve({
                              data: {data: items}
                            })
                          })
                        }
                        // return this.fetchUsers
                  case 'company_contacts':
                    return this.fetchContacts
                        // return getAsyncItems(this.field, this.value)
                    case 'contact':
                        return this.fetchContacts
                    case 'service':
                        return payload => {
                            return new Promise((resolve, reject) => {
                                let items = payload.title ?
                                    _.filter(this.services, item => item.title.toLowerCase().includes(payload.title.toLowerCase())) :
                                    this.services

                                resolve({
                                    data: {data: items}
                                })
                            })
                        }
                }
            },

          start() {  // use a one-off timer
            this.timer = setInterval(() => {
              this.options = this.computedOptions
            }, 1000);
          },

          stop() {
            clearTimeout(this.timer);
          },

          handleOpen(q) {
            if (this.type !== 'custom' && this.type !== 'company_contacts') {
              this.isLoading = true

              this.fetchItems()({
                paginated: true
              })
                  .then(res => {
                    this.options = [
                      ...res.data.data
                    ]
                    return res
                  })
                  .finally(res => {
                    this.isLoading = false
                    return res
                  })

            }

            if (this.type === 'company_contacts') {
              this.isLoading = true

              this.fetchItems()({
                company_id: this.optionsProp2,
                paginated: true
              })
                  .then(res => {
                    this.options = [
                      ...res.data.data
                    ]
                    return res
                  })
                  .finally(res => {
                    this.isLoading = false
                    return res
                  })

            }
          },

          // handleOpen(q = '') {
          //   if (this.type !== 'custom' && this.type !== 'company_contacts') {
          //     this.isLoading = true
          //
          //     this.fetchItems()({
          //       [this.field]: q,
          //       paginated: true
          //     })
          //         .then(res => {
          //           this.options = [
          //             ...res.data.data
          //           ]
          //           return res
          //         })
          //         .finally(res => {
          //           this.isLoading = false
          //           return res
          //         })
          //
          //   }
          //
          //   if (this.type === 'company_contacts') {
          //     this.isLoading = true
          //
          //     this.fetchItems()({
          //       company_id: this.optionsProp2,
          //       paginated: true
          //     })
          //         .then(res => {
          //           this.options = [
          //             ...res.data.data
          //           ]
          //           return res
          //         })
          //         .finally(res => {
          //           this.isLoading = false
          //           return res
          //         })
          //
          //   }
          //   // else{
          //   //     return this.$swal.fire({
          //   //       title: 'Error!',
          //   //       text: 'Please select a company first',
          //   //       icon: 'error',
          //   //       confirmButtonText: 'Ok'
          //   //     })
          //   //   }
          //   },

          handleSearch(q = '') {
                if (this.type !== 'custom' && q != '') {

                  this.isLoading = true

                    this.fetchItems()({
                        [this.field]: q,
                        paginated: true
                    })
                        .then(res => {
                          //console.log(res.data.data)
                            this.options = [
                                ...res.data.data
                            ]
                            return res
                        })
                        .finally(res => {
                            this.isLoading = false
                            return res
                        })
                }
            if (this.type === 'company_contacts') {
              this.isLoading = true

              this.fetchItems()({
                [this.field]: q,
                company_id: this.optionsProp2,
                paginated: true
              })
                  .then(res => {
                    this.options = [
                      ...res.data.data
                    ]
                    return res
                  })
                  .finally(res => {
                    this.isLoading = false
                    return res
                  })

            }
                if(q == '')
                {
                  this.start()
                }
                if (q !== ''){
                  this.stop()
                }
                else{
                    this.$emit('search-changed', q);
                }
            },
        },

        handleClear() {
            this.selected = []
        }
    }
</script>
